import { useState } from 'react';
import { supabase } from '../lib/supabase';
import { Modal, Spinner } from './UI';
import { inputStyle, btnPrimary, colors, fonts, CATEGORIES } from '../lib/styles';

export default function PostListing({ currentUser, onClose, onPosted }) {
  const [form, setForm] = useState({
    title: '', category: 'Tech', description: '',
    location: 'Remote', pricing_type: 'fixed', price: '', urgent: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handlePost = async () => {
    if (!form.title || !form.description) return setError('Title and description are required.');
    if (form.pricing_type === 'fixed' && !form.price) return setError('Enter a price for fixed-rate listings.');
    setLoading(true); setError('');
    try {
      const { error: insertError } = await supabase.from('listings').insert({
        title: form.title,
        description: form.description,
        category: form.category,
        location: form.location,
        pricing_type: form.pricing_type,
        price: form.pricing_type === 'fixed' ? parseInt(form.price) : null,
        urgent: form.urgent,
        user_id: currentUser.id,
      });
      if (insertError) throw insertError;
      onPosted();
      onClose();
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <Modal onClose={onClose}>
      <div style={{ padding: '32px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <h2 style={{ fontFamily: fonts.display, fontSize: '18px', fontWeight: 800, color: colors.cyan, letterSpacing: '0.06em', margin: 0 }}>
            POST A SHIFT
          </h2>
          <button onClick={onClose} style={{
            background: 'transparent', border: `1px solid ${colors.borderMid}`, color: colors.textDim,
            borderRadius: '2px', padding: '4px 10px', cursor: 'pointer', fontFamily: fonts.mono, fontSize: '11px',
          }}>✕ CLOSE</button>
        </div>

        {error && (
          <div style={{ padding: '10px 14px', background: 'rgba(255,60,110,0.08)', border: '1px solid #ff3c6e30', borderRadius: '3px', marginBottom: '16px' }}>
            <p style={{ fontFamily: fonts.mono, fontSize: '12px', color: colors.red, margin: 0 }}>{error}</p>
          </div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div>
            <label style={{ fontFamily: fonts.mono, fontSize: '10px', color: colors.textDim, letterSpacing: '0.1em', display: 'block', marginBottom: '6px' }}>JOB TITLE *</label>
            <input value={form.title} onChange={e => set('title', e.target.value)}
              placeholder="What needs doing?" style={inputStyle} />
          </div>

          <div style={{ display: 'flex', gap: '10px' }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontFamily: fonts.mono, fontSize: '10px', color: colors.textDim, letterSpacing: '0.1em', display: 'block', marginBottom: '6px' }}>CATEGORY</label>
              <select value={form.category} onChange={e => set('category', e.target.value)} style={{ ...inputStyle }}>
                {CATEGORIES.filter(c => c !== 'All').map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontFamily: fonts.mono, fontSize: '10px', color: colors.textDim, letterSpacing: '0.1em', display: 'block', marginBottom: '6px' }}>LOCATION</label>
              <input value={form.location} onChange={e => set('location', e.target.value)}
                placeholder="Remote / City, State" style={inputStyle} />
            </div>
          </div>

          <div>
            <label style={{ fontFamily: fonts.mono, fontSize: '10px', color: colors.textDim, letterSpacing: '0.1em', display: 'block', marginBottom: '6px' }}>DESCRIPTION *</label>
            <textarea value={form.description} onChange={e => set('description', e.target.value)}
              placeholder="Describe the job in detail. More specifics = better bids."
              rows={4} style={{ ...inputStyle, resize: 'vertical' }} />
          </div>

          {/* Pricing type toggle */}
          <div>
            <label style={{ fontFamily: fonts.mono, fontSize: '10px', color: colors.textDim, letterSpacing: '0.1em', display: 'block', marginBottom: '8px' }}>PRICING TYPE</label>
            <div style={{ display: 'flex', gap: '10px' }}>
              {['fixed', 'bid'].map(type => (
                <button key={type} onClick={() => set('pricing_type', type)} style={{
                  flex: 1, padding: '10px', borderRadius: '3px', cursor: 'pointer',
                  fontFamily: fonts.display, fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em',
                  background: form.pricing_type === type ? (type === 'fixed' ? colors.cyan : colors.purple) : 'transparent',
                  color: form.pricing_type === type ? '#000' : (type === 'fixed' ? colors.cyan : colors.purple),
                  border: `1px solid ${type === 'fixed' ? '#00ffc840' : '#a78bfa40'}`,
                  boxShadow: form.pricing_type === type ? `0 0 16px ${type === 'fixed' ? '#00ffc830' : '#a78bfa30'}` : 'none',
                  transition: 'all 0.2s',
                }}>
                  {type === 'fixed' ? 'FIXED PRICE' : 'OPEN TO BIDS'}
                </button>
              ))}
            </div>
          </div>

          {form.pricing_type === 'fixed' && (
            <div>
              <label style={{ fontFamily: fonts.mono, fontSize: '10px', color: colors.textDim, letterSpacing: '0.1em', display: 'block', marginBottom: '6px' }}>BUDGET *</label>
              <div style={{ position: 'relative' }}>
                <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', fontFamily: fonts.display, color: colors.cyan, fontSize: '14px' }}>$</span>
                <input value={form.price} onChange={e => set('price', e.target.value.replace(/\D/g, ''))}
                  placeholder="0" style={{ ...inputStyle, paddingLeft: '28px' }} />
              </div>
            </div>
          )}

          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontFamily: fonts.mono, fontSize: '12px', color: colors.red }}>
            <input type="checkbox" checked={form.urgent} onChange={e => set('urgent', e.target.checked)} style={{ accentColor: colors.red }} />
            MARK AS URGENT
          </label>

          <button onClick={handlePost} disabled={loading} style={{
            ...btnPrimary(loading), width: '100%', padding: '14px', marginTop: '4px',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
            fontSize: '13px', letterSpacing: '0.14em', fontWeight: 800,
          }}>
            {loading && <Spinner size={16} color="#000" />}
            {loading ? 'BROADCASTING...' : 'BROADCAST TO NETWORK'}
          </button>
        </div>
      </div>
    </Modal>
  );
}
